import {
  CalendarOutlined,
  SafetyOutlined,
  GlobalOutlined,
  BuildOutlined,
  KeyOutlined,
  ProjectOutlined,
  InfoCircleOutlined,
  UsergroupAddOutlined,
  SettingOutlined,
  UserOutlined,
  MailOutlined,
  ExclamationCircleOutlined,
  ImportOutlined
} from '@ant-design/icons'

import constants from './constants'

export default {
  ADMIN_MENUS: [
    {
      key: 'ADMIN_ERROR',
      parent: 'ERROR',
      icon: <ExclamationCircleOutlined />,
      label: "common.error",
    },
    {
      key: 'ACCOUNT_DETAILS',
      parent: 'ACCOUNT',
      icon: <UserOutlined />,
      label: "account_details.title",
    },
    {
      key: 'PROJECTS',
      icon: <ProjectOutlined />,
      label: "projects.title",
    },
    {
      key: 'PROJECT_SECRETS',
      parent: 'PROJECTS',
      icon: <SafetyOutlined />,
      label: "secrets.title",
    },
    {
      key: 'PROJECT_ENVIRONMENTS',
      parent: 'PROJECTS',
      icon: <GlobalOutlined />,
      label: "environments.title",
    },
    {
      key: 'PROJECT_LEAKED_SECRETS',
      parent: 'PROJECTS',
      icon: <SafetyOutlined />,
      label: "leaked_secrets.title",
    },
    {
      key: 'PROJECT_ACCESS_KEY',
      parent: 'PROJECTS',
      icon: <KeyOutlined />,
      label: "access_key.title",
    },
    {
      key: 'PROJECT_ACCESS_LOG',
      parent: 'PROJECTS',
      icon: <BuildOutlined />,
      label: "access_log.title",
    },
    {
      key: 'PROJECT_SETTINGS',
      parent: 'PROJECTS',
      icon: <SettingOutlined />,
      label: "settings.title",
      pRoles: [
        constants.PROJECT_MEMBER_ROLE.ADMIN,
      ],
      children: [
        {
          key: 'PROJECT_INFO',
          label: "project_info.title"
        },
        {
          key: 'PROJECT_MEMBERS',
          label: "project_members.title"
        },
      ]
    },
    {
      key: 'EVENTS',
      icon: <CalendarOutlined />,
      label: "events.title",
      wsRoles: [
        constants.WS_MEMBER_ROLE.ADMIN,
      ],
    },
    {
      key: 'WORKSPACE_SETTINGS',
      router: 'WORKSPACE_INFORMATION',
      icon: <SettingOutlined />,
      label: "settings.title",
      wsRoles: [
        constants.WS_MEMBER_ROLE.ADMIN,
      ],
    },
    {
      key: 'WORKSPACE_INFORMATION',
      parent: 'WORKSPACE_SETTINGS',
      icon: <InfoCircleOutlined />,
      label: "information.title",
      wsRoles: [
        constants.WS_MEMBER_ROLE.ADMIN,
      ],
    },
    {
      key: 'WORKSPACE_MEMBERS',
      parent: 'WORKSPACE_SETTINGS',
      icon: <UsergroupAddOutlined />,
      label: "members.title",
      wsRoles: [
        constants.WS_MEMBER_ROLE.ADMIN,
      ],
    },
    {
      key: 'WORKSPACE_IMPORT_EXPORT',
      parent: 'WORKSPACE_SETTINGS',
      icon: <ImportOutlined />,
      label: "import_export.title",
      wsRoles: [
        constants.WS_MEMBER_ROLE.ADMIN,
      ],
    },
    {
      key: 'WORKSPACE_EMAIL_SETTING',
      parent: 'WORKSPACE_SETTINGS',
      icon: <MailOutlined />,
      label: "email_setting.title",
      wsRoles: [
        constants.WS_MEMBER_ROLE.ADMIN,
      ],
    },
  ]
} 
